export const b2bDocumentsTranslations = {
  fields: {
    id: 'ID',
    company_id: 'Company ID',
    savings_funds_request_id: 'Savings Fund Request ID',
    b2b_campaign_id: 'Campaign ID',
    document_url: 'URL',
    document_name: 'Name',
    document_comment: 'Comment',
    type: 'Type',
    task_id: 'Task ID',
    co_sepa_mandate_id: 'SEPA Mandate ID',
    is_archived: 'Archived',
    created_at: 'Created on',
    updated_at: 'Updated on',
    is_generated: 'Generated',
    source: 'Source',
  },
  choices: {
    type: {
      other: 'Other',
      sepa_mandate_rib: 'SEPA Mandate RIB',
      b2b_business_sepa_mandate_form_signed: 'Business SEPA Mandate Form Signed',
      b2b_business_sepa_mandate_form_unsigned: 'Business SEPA Mandate Form Unsigned',
      csg_crds_monthly_summary: 'CSG/CRDS monthly certificate',
      csg_crds_annual_summary: 'CSG/CRDS annual certificate',
      campaign_operation_summary: 'Campaign Operation Summary',
      matching_contribution_fund_request: 'Matching Contribution Fund Request',
      campaign_fund_request: 'Campaign Fund Request',
      in_transfer_report: 'In Transfer Report',
      out_transfer_report: 'Out Transfer Report',
      transfer_in_termination_letter: 'Transfer In Termination Letter',
      transfer_out_termination_letter: 'Transfer Out Termination Letter',
      similar_contract_certificate_document: 'Similar Contract Certificate Document',
      employee_positions_list: 'Employee positions data - FRE211, FRE213, FR313',
      employee_data_fress: 'Employees Data - FRESS',
      company_rib_document: 'Company RIB Document',
      employees_bulk_create: 'Employees Bulk Create',
      b2b_admin_welcome_letter: 'Admin Welcome Letter',
      b2b_pricing: 'Pricing documentation',
      b2b_admin_third_party_mandate: 'Correspondent 3rd-party mandate',
    },
  },
  title: 'Documents',
  categories: {
    company: 'My company',
    contracts: 'My contracts',
    operations: 'My operational documents',
    certificates: 'My certificates',
    commercial_supports: 'My commercial support',
    invoices: 'My invoices',
  },
  empty: 'This company has no documents',
  empty_category: 'No documents in this category',
  button: 'Upload document',
  sections: {
    details: 'Document Details',
  },
  create: {
    title: 'Upload company document',
    success: 'Document uploaded',
    failure: 'Error uploading document: %{error}',
    label: 'Upload Document',
  },
};
